import axios from 'axios'
import { APIurl } from '..'
import { PostDTO } from '../dto'
import { MockPosts } from '../mock'
import { USE_MOCK_DATABASE } from '../../config/mockdb'

export async function GetPosts(): Promise<PostDTO[]> {
    if (USE_MOCK_DATABASE) {
        return MockPosts
    }

    return (await axios.get<PostDTO[]>(APIurl + '/posts', {})).data
}
